const KURULS = [
  {
    "isim": "Yönetim Kurulu",
    "baskan": "Kasım Vural",
    "ekip": [
      "Başkan Yardımcısı: Fahrettin Esin",
      "Sekreter: Metin İlhan",
      "Sayman: M. Fuat Taşdelen",
      "Üye: Yunus Esen"
    ],
    "gorevler": [
      "Derneğin amaçları doğrultusunda faaliyetler planlamak ve yürütmek",
      "Genel kurul kararlarını uygulamak",
      "Derneğin gelir ve giderlerini düzenlemek, mali işleri denetlemek",
      "Üyelerin taleplerini değerlendirmek ve gerekli kararları almak",
      "Derneği resmi kurumlar ve üçüncü kişiler karşısında temsil etmek",
      "Genel kurul toplantısını hazırlamak ve rapor sunmak",
      "Derneğin işleyişi için gerekli komisyon ve çalışma gruplarını oluşturmak"
    ]
  },
  {
    "isim": "Denetim Kurulu",
    "baskan": "KURBAN YORULMAZ",
    "ekip": [
      "SERTAÇ BEKTAŞ",
      "ÜMİT ÖZDEMİR",
      "TUNCAY DAMAR",
      "İLHAMİ KANATLI"
    ],
    "gorevler": [
      "Derneğin tüm faaliyet ve işlemlerini mevzuat ve tüzüğe uygunluk açısından denetlemek",
      "Derneğin hesaplarını, gelir ve gider belgelerini düzenli olarak kontrol etmek",
      "Yönetim kurulunun çalışmalarını incelemek ve gerektiğinde öneriler sunmak",
      "Denetim sonuçlarını rapor haline getirerek genel kurula sunmak",
      "Gerekli gördüğünde yönetim kurulunu olağanüstü genel kurula çağırmak"
    ]
  },  
  {
    "isim": "AG-DER Spor",
    "baskan": "Murat Baysoy",
    "iletisim": "0507 038 73 06",
    "ekip": ["Ayhan Kanatlı"],
    "gorevler": [
      "Futbol takımının antrenman programını hazırlamak ve uygulamak",
      "Takımın maçlara hazırlanması için gerekli çalışmaları organize etmek",
      "Maç ve turnuva organizasyonlarını planlamak ve katılım sağlamak",
      "Takım için gerekli malzeme ve ekipman ihtiyaçlarını karşılamak",
      "Altyapı çalışmaları yaparak genç futbolcuların gelişimini desteklemek",
      "Kulübün futbol faaliyetlerini tanıtmak ve destekçilerle iletişim sağlamak"
    ]
  },  
  {
    "isim": "Sosyal Yardım Kurulu",
    "baskan": "Şeref Aras",
    "ekip": [
      "Metin İlhan",
      "Kasım Vural"
    ],
    "gorevler": [
      "İhtiyaç sahibi üyelere ve ailelerine destek sağlamak",
      "Sosyal yardım projeleri geliştirmek ve yürütmek",
      "Bağış ve yardımların adil şekilde dağıtılmasını sağlamak",
      "Toplum yararına yapılacak faaliyetleri planlamak ve uygulamak",
      "Yardım çalışmalarını düzenli raporlayarak yönetim kuruluna sunmak"
    ]
  },  
  {
    "isim": "Hukuk ve Danışmanlık Kurulu",
    "baskan": "Av. Muhammet Fuat Taşdelen",
    "iletisim": "0533 412 56 89",
    "ekip": ["Avukat BURAK GÜNEŞ", 
      "Avukat ÖMER HAYAT" ],
    "gorevler": [
      "Derneğin hukuki süreçlerini takip etmek",
      "Dernek üyelerine hukuki danışmanlık sağlamak",
      "Resmi yazışmalar ve sözleşmelerde destek olmak",
      "Derneğin tüzük, yönetmelik gibi belgelerini hazırlamak ve güncellemek",
      "Gerekli durumlarda dava ve resmi başvurularda rehberlik etmek"
    ]
  },
  {
    "isim": "Çocuk ve Yaratıcı Atölyeler Kurulu",
    "baskan": "Sertaç Bektaş - Veysel Tekdağ",
    "iletisim": "",
    "ekip": [],
    "gorevler": [
      "Çocuklara yönelik küçük tuğla, seramik ve inşaat temalı yaratıcı atölyeler düzenlemek",
      "Gerekli malzeme ve ekipman teminini sağlamak",
      "Eğitici ustalar ve uzmanlar getirerek çocukların yönlendirilmesini organize etmek",
      "Atölyelerde güvenli ve eğlenceli bir ortam sağlamak",
      "Çocukların el becerilerini geliştirecek farklı aktiviteler planlamak"
    ]
  }, 
  {
    "isim": "İnşaat ve Yapı Projeleri Kurulu",
    "baskan": "Veysel Tekdağ",
    "iletisim": "0553 412 33 21",
    "ekip": ["Mehmet Ali Yıldız", "Hasan Tuncel"],
    "gorevler": [
      "Dernek binası bakım, onarım ve tadilatlarını planlamak ve yürütmek",
      "Yeni projelerde (misafirhane, kültür merkezi vs.) fizibilite ve inşaat işleriyle ilgilenmek",
      "Üyelerin ihtiyaçlarına yönelik teknik destek sunmak (ev tadilatı, tamirat önerileri)",
      "İnşaat sektöründe çalışan üyeleri bir araya getirerek dayanışmayı artırmak"
    ]
  }, 
  {
    "isim": "Dekorasyon ve İç Mekân Düzenleme Kurulu",
    "baskan": "Murat Baysoy",
    "ekip": ["Serkan Ayaz", "Emrah Gül"],
    "gorevler": [
      "Dernek binası iç dekorasyonu, boya, alçı ve benzeri işlerin düzenlenmesi",
      "Etkinlikler öncesi alan hazırlığı ve estetik düzenlemeleri yapmak",
      "Taziye, düğün gibi organizasyonlarda alan kurulumu desteği sağlamak",
      "İnşaat ve yapı işleriyle ilgili malzeme temini ve iş gücü koordinasyonunda destek olmak"
    ]
  },    
  {
    "isim": "Üye İlişkileri ve Gönüllülük Kurulu",
    "baskan": "Kasım Vural",
    "ekip": ["Fahrettin Esin","Metin İlhan"],
    "iletisim": "0544 587 22 69",
    "gorevler": [
      "Dernek üyeleri ile iletişimi sağlamak",
      "Gönüllü faaliyetlerini organize etmek",
      "Üye kayıt ve takibini yapmak"
    ]
  },
  {
    "isim": "Hemşehri Dayanışma ve Sosyal Destek Kurulu",
    "baskan": "Menaf Tuna",
    "iletisim":"0536 460 17 94",
    "ekip": [],
    "gorevler": [
      "Hemşehriler arasında dayanışmayı güçlendirmek",
      "Sosyal yardım ve destek programları yürütmek",
      "İhtiyaç sahiplerine ulaşmak ve destek olmak"
    ]
  },
  {
    "isim": "Strateji ve Gelişim Kurulu",
    "baskan": "Kurban Yorulmaz",
    "ekip": ["Metin İlhan","Kamuran Vural"],
    "gorevler": [
      "Derneğin uzun vadeli stratejilerini belirlemek",
      "Yenilikçi projeler geliştirmek",
      "Dernek yönetimini desteklemek"
    ]
  },
  {
    "isim": "İstihdam ve Kariyer Destek Kurulu",
    "baskan": "Mehmet Baysoy",
    "ekip": [],
    "gorevler": [
      "İş arayanlar için destek sağlamak",
      "Kariyer planlama ve iş bulma faaliyetleri düzenlemek",
      "Mesleki eğitimler ve seminerler organize etmek",
      "Tatil dönemindeki çocuklara çıraklık ayarlamak"
    ]
  },
  {
    "isim": "Esnaf ve Ticaret Gelişim Kurulu",
    "baskan": "Yunus Esen",
    "iletisim": "0532 525 31 62", 
    "ekip": [],
    "gorevler": [
      "Esnafları bir araya getirerek ticari dayanışmayı sağlamak",
      "Pazarlama ve satış artırıcı etkinlikler yapmak",
      "Esnafın ihtiyaç ve taleplerini dernek yönetimine iletmek"
    ]
  },
  {
    "isim": "Kaynak ve Sponsorluk Kurulu",
    "baskan": "Kasım Vural",
    "iletisim":"0533 604 85 08",
    "ekip": ["Ahmet Taylan", "Cihan Ünal"],
    "gorevler": [
      "Derneğe finansal kaynak sağlamak",
      "Sponsorluklar ve bağışlar organize etmek",
      "Kurumsal destekçilerle iletişim kurmak"
    ]
  },
  {
    "isim": "Kadın Gelişim ve Dayanışma Kurulu",
    "baskan": "Nurten Bulut",
    "iletisim" : "0555 184 64 16", 
    "ekip": ["Metin İlhan","Oya Koyuncu"],
    "gorevler": [
      "Kadınların sosyal ve ekonomik gelişimini desteklemek",
      "Kadınlara yönelik eğitim ve etkinlikler düzenlemek",
      "Kadın dayanışmasını artırıcı projeler yapmak"
    ]
  },
  {
    "isim": "Engelleri Kaldırma Kurulu",
    "baskan": "Oya Koyuncu",
    "iletisim" : "", 
    "ekip": ["Metin İlhan"],
    "gorevler": [
      "Engelliler için sosyal ve ekonomik gelişimini desteklemek",
      "Engellilere yönelik eğitim ve etkinlikler düzenlemek",
    ]
  },
  {
    "isim": "Çocuk Etkinlikleri ve Gelişim Kurulu",
    "baskan": "Oya Koyuncu",
    "iletisim" : "0542 812 88 72", 
    "ekip": ["Fahrettin Esin","Metin Ilhan"],
    "gorevler": [
      "Çocuklara yönelik sosyal ve kültürel etkinlikler düzenlemek",
      "Çocukların kişisel gelişimlerine katkıda bulunmak",
      "Özel günlerde çocuklara yönelik programlar yapmak"
    ]
  },
  {
    "isim": "Dış İlişkiler ve Kurumsal İş Birliği Kurulu",
    "baskan": "Erbil Baysal",
    "iletisim": "05324780487",
    "ekip": [],
    "gorevler": [
      "STK'lar ile iletişim ve İş birliği",
      "Resmi kurumlar ve diğer derneklerle iletişim kurmak",
      "Destek ve iş birliği fırsatları aramak",
      "Protokol ve anlaşmalar yapmak"
    ]
  }, 
  {
    "isim": "Sanat, Müzik, Tiyatro ve Gösteri Kurulu",
    "baskan": "Fahrettin Esin",
    "iletisim": "05054841050",
    "ekip": [],
    "gorevler": [
      "Tiyatro ve sahne sanatları etkinlikleri düzenlemek",
      "Sanatçı davetleri ve gösteriler organize etmek",
      "Dernek bünyesinde kültürel sanat faaliyetlerini yürütmek"
    ]
  },
  {
    "isim": "Salon Yönetim Kurulu",
    "baskan": "Kenan Kanatlı",
    "ekip": ["Veysel Tekdağ","Şeref Aras", "Metin İlhan","Sertaç Bektaş"],
    "gorevler": [
      "Dernek binasının taziye, düğün ve organizasyonlar için hazırlanması",
      "Salon kullanımını düzenlemek ve yönetmek",
      "Organizasyonların sorunsuz geçmesini sağlamak"
    ]
  },
  {
    "isim": "Ağrı Merkez Temsil Kurulu",
    "baskan": "Servet Taşdemir",
    "iletisim":"05053948665",
    "ekip": [],
    "gorevler": [
      "Ağrı merkez hemşehrilerini derneğe kazandırmak",
      "İhtiyaç ve talepleri derneğe iletmek",
      "Merkez ilçeyle ilgili kültürel ve sosyal etkinlikler düzenlemek"
    ]
  },
  {
    "isim": "Patnos Temsil Kurulu",
    "baskan": "Erbil Baysal",
    "ekip": ["Metin Garip"],
    "gorevler": [
      "Patnos ilçesi hemşehrilerini derneğe kazandırmak",
      "İhtiyaç ve talepleri derneğe iletmek",
      "Patnos ile ilgili etkinlikler ve dayanışma sağlamak"
    ]
  },
  {
    "isim": "Doğubayazıt Temsil Kurulu",
    "baskan": "Ahmet Orhan",
    "ekip": ["Metin İlhan"],
    "gorevler": [
      "Doğubayazıt hemşehrilerini derneğe kazandırmak",
      "İhtiyaç ve talepleri derneğe iletmek",
      "Doğubayazıt ile ilgili sosyal ve kültürel faaliyetler düzenlemek"
    ]
  },
  {
    "isim": "Tutak Temsil Kurulu",
    "baskan": "Mehmet Polat",
    "ekip": [],
    "gorevler": [
      "Tutak hemşehrilerini derneğe kazandırmak",
      "İhtiyaç ve talepleri derneğe iletmek",
      "Tutak ilçesi için özel etkinlikler yapmak"
    ]
  },
  {
    "isim": "Diyadin Temsil Kurulu",
    "baskan": "Metin Garip",
    "ekip": [],
    "gorevler": [
      "Diyadin hemşehrilerini derneğe kazandırmak",
      "İhtiyaç ve talepleri derneğe iletmek",
      "Diyadin ilçesi için sosyal dayanışma faaliyetleri düzenlemek"
    ]
  },
  {
    "isim": "Taşlıçay Temsil Kurulu",
    "baskan": "Doğan Yerlikaya",
    "iletisim":"05418799492",
    "ekip": [],
    "gorevler": [
      "Taşlıçay hemşehrilerini derneğe kazandırmak",
      "İhtiyaç ve talepleri derneğe iletmek",
      "Taşlıçay ilçesi kültürel etkinlikler organize etmek"
    ]
  },
  {
    "isim": "Eleşkirt Temsil Kurulu",
    "baskan": "Şeref Aras-Ömer Kahriman",
    "iletisim":"05537665721",
    "ekip": [],
    "gorevler": [
      "Eleşkirt hemşehrilerini derneğe kazandırmak",
      "İhtiyaç ve talepleri derneğe iletmek",
      "Eleşkirt ilçesi sosyal faaliyetler düzenlemek"
    ]
  },
  {
    "isim": "Hamur Temsil Kurulu",
    "baskan": "Ümit Özdemir",
    "ekip": ["Harun Özdemir","Mehmet Hanifi Abak"],
    "gorevler": [
      "Hamur hemşehrilerini derneğe kazandırmak",
      "İhtiyaç ve talepleri derneğe iletmek",
      "Hamur ilçesi için kültürel ve sosyal etkinlikler yapmak"
    ]
  },
  {
    "isim": "Spor Organizasyonları ve Etkinlikler Kurulu",
    "baskan": "Vezir Gündüz",
    "iletisim": "05526150404",
    "ekip": ["Murat Baysoy"],
    "gorevler": [
      "Spor etkinlikleri ve turnuvalar düzenlemek",
      "Gençleri ve üyeleri spora teşvik edici projeler geliştirmek",
      "Dernek adına spor organizasyonları planlamak ve yürütmek",
      "Resmi ve özel günlerde sportif faaliyetler organize etmek"
    ]
  },
  {
    "isim": "Üye Talep ve Destek Kurulu",
    "baskan": "Mehmet Nasır Baysoy",
    "iletisim": "05xx xxx xx xx",
    "ekip": [],
    "gorevler": [
      "Üyelerden gelen talepleri ve şikayetleri toplamak",
      "Üye problemlerini çözmek için gerekli adımları planlamak ve uygulamak",
      "Dernek içi ve dışı koordinasyon ile çözüm süreçlerini yürütmek",
      "Üyelerin memnuniyetini takip etmek ve raporlamak",
      "Talep ve sorunlara ilişkin düzenli geri bildirim sağlamak"
    ]
  },
  {
    "isim": "Dini ve Manevi Rehberlik Kurulu",
    "baskan": "Mahmut Köçer",
    "ekip": [],
    "gorevler": [
      "Dini etkinlikler ve manevi rehberlik sağlamak",
      "İhtiyar heyetiyle koordinasyon sağlamak",
      "Vefat eden üyelerin taziyesi ve dualarını organize etmek"
    ]
  },
  {
    "isim": "Gençlik ve Eğitim Kurulu",
    "baskan": "Mehmet Durak",
    "ekip": ["Metin İlhan"],
    "gorevler": [
      "Gençlere yönelik eğitim ve sosyal projeler geliştirmek",
      "Kariyer destek programları organize etmek",
      "Gençlik aktiviteleri ve seminerler düzenlemek"
    ]
  },

  {
    "isim": "Tanıtım ve Sosyal Medya Kurulu",
    "baskan": "Metin İlhan",
    "ekip": [],
    "gorevler": [
      "Derneğin tanıtımını yapmak",
      "Sosyal medya hesaplarını yönetmek",
      "Basın ve medya ile iletişim sağlamak"
    ]
  }
]

export default KURULS
